import React, { useState, useEffect } from "react";
import { getMyAssetList } from "../../services/AssetService";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { Link } from "react-router-dom";
import { UnitStatusBadge } from "../../components/CustomTooltip";
import { format } from "date-fns";
import { IoReturnDownBackSharp, IoSwapHorizontal } from "react-icons/io5";
import AssetReturnModal from "../Asset/ActionModal/AssetReturnModal";
import { IoIosWarning } from "react-icons/io";
import AssetReturnCancelModal from "../Asset/ActionModal/AssetReturnCancelModal";
import AssetTransferModal from "../Asset/ActionModal/AssetTransferModal";


const OwnAsset = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [total, setToatl] = useState(0);
  const [selectedData, setSelecetdData] = useState(null);
  const [assetReturnModal, setAssetReturnModal] = useState(false);
  const [assetReturnCancelModal, setAssetReturnCancelModal] = useState(false);
  const [showAssetTransferModal, setShowAssetTransferModal] = useState(false);
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
  });

  const handleToggleAssetReturnModal = () => {
    setAssetReturnModal(!assetReturnModal);
  };
  const handleToggleAssetReturnCancelModal = () => {
    setAssetReturnCancelModal(!assetReturnCancelModal);
  };
  const handleToggleAssetTransferModal = () => {
    setShowAssetTransferModal(!showAssetTransferModal)
  }
  const getAssetList = () => {
    setLoading(true);
    getMyAssetList(param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setToatl(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getAssetList();
  }, [param]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  const handlAfterAssetReturnSubmit = () => {
    handleToggleAssetReturnModal();
    getAssetList();
  };

  const handlAfterAssetReturnCancelSubmit = () => {
    handleToggleAssetReturnCancelModal();
    getAssetList();
  };

  const handlAfterAssetTransferSubmit = () => {
    handleToggleAssetTransferModal()
    getAssetList();
  };
  return (
    <div className="card">
      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      ) : error ? (
        <div className="text-center my-4 text-danger">{error}</div>
      ) : data && data?.length > 0 ? (
        <div className="table-responsive">
          <table className="table fs-6 mb-0 align-middle">
            <thead className="table-light custom-thead">
              <tr>
                <th>Asset Number</th>
                <th>Model</th>
                <th>Brand</th>
                <th>Serial Number</th>
                <th>Price</th>
                <th>Allocate Date</th>
                <th>Allocate By</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((asset, index) => (
                <tr key={asset.id}>
                  <td>{asset?.asset_number || "-"}</td>
                  <td>{asset?.model_number || "-"}</td>
                  <td>{asset?.brand || "-"}</td>
                  <td>{asset?.serial_number || "-"}</td>
                  <td>{`₹${asset?.purchase_cost}` || "-"}</td>
                  <td>
                    {asset?.allocated_at
                      ? format(asset?.allocated_at, "dd MMM yyy")
                      : "-"}
                  </td>
                  <td>
                    {asset?.allocated_by?.name || "-"}
                    {/* <UnitStatusBadge status={asset?.status} /> */}
                  </td>
                  {/* <td>
                    {asset?.is_return_requested ? (
                      <button
                        className="btn rounded-2 btn-sm btn-danger"
                        style={{ padding: "0rem 0.5rem" }}
                        onClick={() => {
                          setSelecetdData(asset);
                          handleToggleAssetReturnCancelModal();
                        }}
                      >
                        Cancel Return
                        <IoIosWarning className="ms-1" />
                      </button>
                    ) : (
                      <button
                        className="btn rounded-2 btn-sm stylish-transparent-btn"
                        style={{ padding: "0rem 0.5rem" }}
                        onClick={() => {
                          setSelecetdData(asset || "");
                          handleToggleAssetReturnModal();
                        }}
                      >
                        Return
                        <IoReturnDownBackSharp className="ms-1" />
                      </button>
                    )}
                  </td> */}
                  <td>
                    <div className="d-flex flex-wrap gap-2">
                      {asset?.is_return_requested ? (
                        <button
                          className="btn btn-sm btn-danger rounded-2"
                          style={{ padding: "0rem 0.5rem" }}
                          onClick={() => {
                            setSelecetdData(asset);
                            handleToggleAssetReturnCancelModal();
                          }}
                        >
                          Cancel Return <IoIosWarning className="ms-1" />
                        </button>
                      ) : (
                        <>
                          <button
                            className="btn btn-sm stylish-transparent-btn rounded-2"
                            style={{ padding: "0rem 0.5rem" }}
                            onClick={() => {
                              setSelecetdData(asset || "");
                              handleToggleAssetReturnModal();
                            }}
                          >
                            Return <IoReturnDownBackSharp className="ms-1" />
                          </button>

                          <button
                            className="btn btn-sm btn-primary rounded-2"
                            style={{ padding: "0rem 0.5rem" }}
                            disabled={asset?.is_transfer_requested}
                            onClick={() => {
                              setSelecetdData(asset || "");
                              handleToggleAssetTransferModal();
                            }}
                          >
                            Transfer <IoSwapHorizontal className="ms-1" />
                          </button>
                        </>
                      )}
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center my-4">No data found</div>
      )}
      {!loading && data?.length > 0 && (
        <div className="p-4">
          <Pagination
            currentPage={param.page}
            recordsPage={param.page_size}
            dataLength={total}
            handlePagination={handlePageChange}
          />
        </div>
      )}

      <AssetReturnModal
        assetData={selectedData}
        open={assetReturnModal}
        onClose={handleToggleAssetReturnModal}
        afterSubmit={handlAfterAssetReturnSubmit}
      />

      <AssetReturnCancelModal
        assetData={selectedData}
        open={assetReturnCancelModal}
        onClose={handleToggleAssetReturnCancelModal}
        afterSubmit={handlAfterAssetReturnCancelSubmit}
      />

      {showAssetTransferModal && (
        <AssetTransferModal
          open={showAssetTransferModal}
          onClose={handleToggleAssetTransferModal}
          asset={selectedData}
          afterSubmit={handlAfterAssetTransferSubmit}
        />
      )}

    </div>
  );
};

export default OwnAsset;
